module.exports = __webpack_public_path__ + "img/store_vip_benefit_ads.9f0140bd.png";